import { PropsWithChildren, ReactNode } from 'react';

type Props = {
  href?: string;
  linkText?: string;
  title: string;
  icon: ReactNode;
  trackerClass?: string;
  horizontalLayout?: boolean;
} & ClassNameProp;

type WrapperProps = Pick<Props, 'href' | 'className' | 'trackerClass'>;

const IconCalloutWrapper = ({ href, trackerClass, className, children }: PropsWithChildren<WrapperProps>) => {
  const wrapperClasses = ['flex', 'justify-center', 'border-1', 'border-gray-light'];

  className && wrapperClasses.push(className);
  trackerClass && wrapperClasses.push(trackerClass);

  if (href) {
    return (
      <a href={href} className={wrapperClasses.join(' ')}>
        {children}
      </a>
    );
  }

  return <div className={wrapperClasses.join(' ')}>{children}</div>;
};

export const IconCallout = ({ href, linkText, title, icon, trackerClass, horizontalLayout, className }: Props) => {
  return (
    <IconCalloutWrapper href={href} trackerClass={trackerClass} className={className}>
      <div className={`m-auto flex ${horizontalLayout ? 'flex-row' : 'flex-col'} items-center`}>
        {horizontalLayout ? icon : <div className="flex h-[44px]">{icon}</div>}

        <p className={`${horizontalLayout ? 'ml-4' : 'mt-4'} text-sm text-gray-darker`}>{title}</p>

        {linkText && <p className="text-anchor text-xs"> {linkText}</p>}
      </div>
    </IconCalloutWrapper>
  );
};
